<div class="wrapper mt-3">
    	<app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
<div class="teacher-management-container mt-5">
        <mat-tab-group class="custom-tabs">
            <mat-tab label="By Teacher">
                <div class="analytics-wrapper">
                    <div class="header">
                        <h3>Teacher-wise Statistics</h3>
                    </div>
                    <ng-container *ngIf="isloading; else pageContent">
                        <div class="app-spinner">
						<mat-spinner diameter="60"></mat-spinner>
						</div>
					</ng-container>
                    <ng-template #pageContent>
						<ng-container *ngIf="teachersData.length > 0; else noTeachersFound">
                        <p-table [value]="teachersData" class="custom-p-table responsive-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Teacher Name</th>
                                    <th>Classrooms</th>
                                    <th>Courses Created</th>
                                    <th>Quizzes Created</th>
                                    <th>Students Enrolled</th>
                                    <!-- <th>Performance</th> -->
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-teacher>
                                <tr>
                                    <td>{{ teacher.teacher_name }}</td>
                                    <td><span class="pill">{{ teacher.total_classrooms }}</span></td>
                                    <td><span class="pill">{{ teacher.total_courses }}</span></td>
                                    <td><span class="pill">{{ teacher.total_quizzes }}</span></td>
                                    <td>{{ teacher.total_students }}</td>
                                    <!-- <td><span class="status high">{{ teacher.performance }}</span></td> -->
                                </tr>
                            </ng-template>
                        </p-table>
						</ng-container>
						<ng-template #noTeachersFound>
							<p>no teachers available</p>
						</ng-template>
                    </ng-template>
                </div>
            </mat-tab>
            <!-- <mat-tab label="By Batch">
                <div class="analytics-wrapper">
                    <div class="header">
                        <h3>Batch-wise Statistics</h3>
                    </div>

                    <div *ngIf="loading" class="loader">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>

                    <div *ngIf="!loading">
                        <p-table [value]="teachers" class="custom-p-table responsive-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Teacher Name</th>
                                    <th>Classrooms</th>
                                    <th>Courses Created</th>
                                    <th>Quizzes Created</th>
                                    <th>Students Enrolled</th>
                                    <th>Performance</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-teacher>
                                <tr>
                                    <td>{{ teacher.name }}</td>
                                    <td><span class="pill">{{ teacher.classrooms }}</span></td>
                                    <td><span class="pill">{{ teacher.courses }}</span></td>
                                    <td><span class="pill">{{ teacher.quizzes }}</span></td>
                                    <td>{{ teacher.students }}</td>
                                    <td><span class="status high">{{ teacher.performance }}</span></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Course Engagement">
                <div class="analytics-wrapper">
                    <div class="header">
                        <h3>Course Engagement Statistics</h3>
                    </div>

                    <div *ngIf="loading" class="loader">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>

                    <div *ngIf="!loading">
                        <p-table [value]="teachers" class="custom-p-table responsive-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Teacher Name</th>
                                    <th>Classrooms</th>
                                    <th>Courses Created</th>
                                    <th>Quizzes Created</th>
                                    <th>Students Enrolled</th>
                                    <th>Performance</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-teacher>
                                <tr>
                                    <td>{{ teacher.name }}</td>
                                    <td><span class="pill">{{ teacher.classrooms }}</span></td>
                                    <td><span class="pill">{{ teacher.courses }}</span></td>
                                    <td><span class="pill">{{ teacher.quizzes }}</span></td>
                                    <td>{{ teacher.students }}</td>
                                    <td><span class="status high">{{ teacher.performance }}</span></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </mat-tab> -->
        </mat-tab-group>
    </div>
</div>